export const primaryColor = '#F5D547';
export const secondaryColor = '#1A1F16';
